import React from "react";
import isEqual from "lodash/isEqual";

export default function SetInitialValues(mapPropsToValues) {
  return WrappedComponent => {
    class SetInitialValues extends React.Component {
      shouldComponentUpdate(nextProps) {
        return !isEqual(this.props, nextProps);
      }

      render() {
        return (
          <WrappedComponent
            {...this.props}
            initialValues={mapPropsToValues(this.props)}
          />
        );
      }
    }

    const wrappedComponentName =
      WrappedComponent.displayName || WrappedComponent.name || "Component";

    SetInitialValues.displayName = `setInitialValues(${wrappedComponentName})`;
    return SetInitialValues;
  };
}



// WEBPACK FOOTER //
// ./src/hocs/setInitialValues.js